import {
  AdminLayout,
  useSource,
  useTranslation,
  useUrlParam,
} from "@opendash/core";
import { AdminToolbar } from "@opendash/ui";
import { observer } from "mobx-react-lite";
import React from "react";
import { ItemsTable } from "../../features/items";

export const ItemsPage = observer(() => {
  const [searchString, setSearchString] = useUrlParam<string>(
    "query",
    "",
    "string"
  );
  const t = useTranslation();
  const [selectedSource] = useSource();

  return (
    <AdminLayout contentPadding>
      <AdminToolbar
        onSearch={setSearchString}
        searchInitial={searchString}
        title={t("maintenance:items.view.headline") + " " + selectedSource.name}
      />
      <div className="od-page-main">
        <ItemsTable filterSource />
      </div>
    </AdminLayout>
  );
});
